// Configuration for environment-specific settings
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// API URLs
const DEV_API_URL = 'http://localhost:5000/api';
const PROD_API_URL = 'https://docuassistv2.azurewebsites.net/api';

export const API_BASE_URL = isDevelopment ? DEV_API_URL : PROD_API_URL;

// You can add more environment-specific configurations here
export const config = {
    apiBaseUrl: API_BASE_URL,
    // Add other configuration items as needed
}; 